import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Shop } from "iconsax-react";
import { memo, useState } from "react";

import { resolveMediaUrl } from "@/lib/media";
import type { ProductIconTileProps } from "./ProductIconTile.types";
import * as styles from "./ProductIconTile.styles";

export type { ProductIconTileProps } from "./ProductIconTile.types";

export const ProductIconTile = memo(function ProductIconTile({
  icon,
  imageUrl,
  alt = "",
  size = 42,
}: ProductIconTileProps) {
  const theme = useTheme();
  const iconSize = Math.round(size * 0.52);
  const src = resolveMediaUrl(imageUrl);
  const [failedSrc, setFailedSrc] = useState<string>();
  const showImage = Boolean(src) && failedSrc !== src;

  return (
    <Box sx={styles.root(size)}>
      {showImage ? (
        <Box
          component="img"
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setFailedSrc(src)}
          sx={styles.image}
        />
      ) : (
        (icon ?? <Shop size={iconSize} variant="Bold" color={theme.palette.text.secondary} />)
      )}
    </Box>
  );
});
